import { createAction, props } from '@ngrx/store';
import { loginType } from '../../core/models/Interfaces/login';

export const loginRequest = createAction(
  'login-request',
  props<{ loginParams: loginType }>(),
);
export const loginReceived = createAction(
  'login-received',
  props<{ data: any }>(),
);
export const loginFailed = createAction('login-failed', props<{ data: any }>());

export const termsAndConditionsRequest = createAction(
  'terms-and-conditions-request',
  props<{ params: string; requestType: string }>(),
);
